import { Formik } from 'formik';

import type { SectionTemplatePage_OneSectionTemplate } from '../../pages/SectionTemplate/hooks/useFindOneSectionTemplateQuery.hook';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { SectionTemplateInfoSchema } from './schemas/section-template-info.schema';
import { SectionTemplateInfoFormFields } from './SectionTemplateInfoFormFields';

interface Props {
  readonly initialValues?: SectionTemplatePage_OneSectionTemplate;
  readonly onCancel?: () => void;
  readonly onSuccess?: () => void;
  readonly setMustBlockAction?: (mustBlock: boolean) => void;
  readonly showCancelButton?: boolean;
  readonly submitLabel?: string;
  readonly title: string;
  readonly useSubmitFactory: (
    handleSuccess?: () => void,
  ) => (sectionTemplate: SectionTemplatePage_OneSectionTemplate) => void;
}

export const SectionTemplateInfoForm = ({
  initialValues: pInitialValues,
  onCancel: handleCancel,
  onSuccess: handleSuccess,
  setMustBlockAction,
  showCancelButton,
  submitLabel = 'Valider',
  title,
  useSubmitFactory,
}: Readonly<Props>) => {
  const { initialValues } = useInitialValuesFactory(pInitialValues);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={useSubmitFactory(handleSuccess)}
      validationSchema={SectionTemplateInfoSchema}
    >
      <SectionTemplateInfoFormFields
        onCancel={handleCancel}
        setMustBlockAction={setMustBlockAction}
        showCancelButton={showCancelButton}
        submitLabel={submitLabel}
        title={title}
      />
    </Formik>
  );
};
